<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import IconReports from '@/components/icons/IconReports.vue';
import PageView from '@/components/ui/PageView.vue';
import SectionTabView from '@/components/ui/SectionTabView.vue';
import ReportsPaymentsTab from '@/views/reports/ReportsPaymentsTab.vue';
import ReportsAccountsTab from '@/views/reports/ReportsAccountsTab.vue';
import ReportsPortfolioRiskTab from '@/views/reports/ReportsPortfolioRiskTab.vue';
import type { SectionTab } from '@/components/ui/SectionTabView.vue';

type ReportsTabId = 'payments' | 'accounts' | 'portfolio-risk';

const TABS: SectionTab[] = [
    { id: 'payments', label: 'Payments' },
    // PHASE2
    // { id: 'accounts', label: 'Accounts' },
    { id: 'portfolio-risk', label: 'Portfolio Risk' },
];

const DEFAULT_TAB_ID: ReportsTabId = 'payments';

const route = useRoute();
const router = useRouter();

const isReportsTabId = (value: unknown): value is ReportsTabId => (
    typeof value === 'string'
    && TABS.some((tab) => tab.id === value)
);

const activeTabId = computed<ReportsTabId>(() => {
    const tab = Array.isArray(route.query.tab)
        ? route.query.tab[0]
        : route.query.tab;

    return isReportsTabId(tab) ? tab : DEFAULT_TAB_ID;
});

const selectTab = (tabId: string) => {
    if (!isReportsTabId(tabId) || tabId === activeTabId.value) {
        return;
    }

    const nextQuery = { ...route.query };

    if (tabId === DEFAULT_TAB_ID) {
        delete nextQuery.tab;
    } else {
        nextQuery.tab = tabId;
    }

    router.push({
        name: 'reports',
        query: nextQuery,
    });
};
</script>

<template>
    <PageView title="Reports" :icon="IconReports">
        <SectionTabView
            :tabs="TABS"
            :active-tab-id="activeTabId"
            @tab-change="selectTab"
        >
            <div class="reports-tab-content">
                <ReportsPaymentsTab v-if="activeTabId === 'payments'" />
                <ReportsAccountsTab v-else-if="activeTabId === 'accounts'" />
                <ReportsPortfolioRiskTab v-else-if="activeTabId === 'portfolio-risk'" />
            </div>
        </SectionTabView>
    </PageView>
</template>

<style lang="scss" scoped>
</style>
